<template>
	<div>
    <b-row>
      <b-col cols="10" md="4" sm="6">
				<div class="panel">
					<div class="panel-default">
						<form @submit.prevent="login()">
							<b-form-group id="loginFormGroup" :label="translation.loginArea.user" label-for="login-input" label-align="right" label-size="sm" label-cols="3">
								<b-form-input id="login-input" v-model="user" size="sm" :placeholder="translation.loginArea.user" required class="col-10"/>
							</b-form-group>
							<b-form-group id="passwordFormGroup" :label="translation.loginArea.pass" label-for="password-input" label-align="right" label-size="sm" label-cols="3">
								<b-form-input id="password-input" type="password" v-model="password" size="sm" :placeholder="translation.loginArea.pass" required class="col-10" />
							</b-form-group>
							<b-form-row class="justify-content-end">
								<b-button type="submit" size="sm"> {{ translation.loginArea.enter }}</b-button>
							</b-form-row>
						</form>
					</div>
					<div class="panel-footer">
    			  <a
    			    role="button"
    			    href="javascript:void(0)"
    			    @click="forgotPassoword"
    			  >Recover your password!</a>
    			</div>
				</div>
      </b-col>
    </b-row>
	</div>
</template>

<script>
import LoginService from '../../services/LoginService';
import { translate } from '../../assets/translations';

export default {
	data() {
		return {
			user: "",
			password: "",
			loginService: new LoginService(),
		};
	},
	computed:{
		translation() {
			return translate(this.$store.state.language);
		},
	},
	methods: {
		login() {
			this.loginService.login({ login: this.user, password: this.password })
			.then((res) => {
				this.$store.dispatch("login", { token: res.data.key });
				this.$store.dispatch("loadUserInfo", res.data);
        this.$router.push('/search');
			})
			.catch((error) =>
				this.$store.dispatch("showAlert", {
					message: this.translation.loginArea.errorMsg,
					code: 0,
					style: "danger"
				})
			);
		},
		forgotPassoword() {
      if (!this.user) {
        alert("Enter your email in the login field!");
        return;
      }
      this.loginService.sendResetPassword(this.user)
        .then((res) =>
          this.$store.dispatch("showAlert", {
            message: "Email was sent! Check your inbox.",
            code: 0,
            style: "success"
          })
        )
        .catch((error) => {
          this.$store.dispatch("showAlert", {
            message: error.response ? error.response.data.message : "Error resetting password!",
            code: 0,
            style: "danger"
          });
        });
    }
	}
};
</script>

<style scoped>
.row {
	justify-content: center;
}

.panel {
	margin: 50px 0px 20px 0px;
	box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.14),
		0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	background-color: #e8e8e8;
	border: 1px solid transparent;
	border-radius: 4px;
	padding: 15px;

}

.panel-footer {
	margin-top: 1rem;
	padding: 1px 15px;
	color: #a0a0a0;
	background-color: #e8e8e8;
	border-top: 1px solid #ddd;
	border-bottom-right-radius: 3px;
	border-bottom-left-radius: 3px;
}

.btn {
	background-color: #0f2b40;
}

.btn:hover {
	background-color: #042035 !important;
	border-color: #042035 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue